import { toast } from "react-toastify";
import {
  fetchReservationSummarySuccess,
  fetchReservationSummaryFailure,
  fetchYearlySummarySuccess,
  fetchYearlySummaryFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_RESERVATION_SUMMARY_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

export const getReservationSummary =
  (setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    await determineBaseUrlAndPerformApiCall(
      `${GET_RESERVATION_SUMMARY_API}?period=${dateRange?.period || "3m"}${
        dateRange?.period === "custom"
          ? `&from=${dateRange?.from}&to=${dateRange?.to}`
          : ""
      }`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          dispatch(fetchReservationSummarySuccess(response || {}));
          // dispatch(setSuccessMessage(true));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchReservationSummarySuccess({}));
          } else {
            dispatch(fetchReservationSummaryFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };

export const getYearlySummary = (setLoading) => async (dispatch) => {
  setLoading(true);
  await determineBaseUrlAndPerformApiCall(
    `${GET_RESERVATION_SUMMARY_API}?period=12m`,
    "GET"
  )
    .then((response) => {
      setLoading(false);
      if (!response.error) {
        dispatch(fetchYearlySummarySuccess(response || {}));
        // dispatch(setSuccessMessage(true));
      }
      if (response.error) {
        if (response.error.code === "NotFound") {
          dispatch(fetchYearlySummarySuccess({}));
        } else {
          dispatch(fetchYearlySummaryFailure(response.error.message));
          toast.error(`${response.error.message}`);
        }
      }
    })
    .catch((errorResp) => {});
};
